import React from 'react'
import { FormGroup, FormControl } from 'react-bootstrap'

import Label from 'live/components/forms/ui/label'
import authorization from 'live/services/authorization'
import i18n from 'live/services/i18n'

import { EntityEditorModal } from '../../../../../generic'
import { IEditorEscalation } from '../../BarrierEditor'

type IProps = {
    handleClose: () => void
    handleChange: () => void
    isOpen: boolean
    item: IEditorEscalation[]
    borderColor: string
    title: string
}

export const EscalationEditModal: React.FC<IProps> = ({
    handleClose,
    isOpen,
    item,
    handleChange,
    borderColor,
    title
}) => {
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN

    if (!item) {
        return <></>
    }

    return (
        <EntityEditorModal
            handleClose={handleClose}
            isOpen={isOpen}
            borderColor={borderColor}
            headerTitle={i18n(title)}
            headerSubtitle={item[0]?.id ? '#' + item[0]?.id : ''}
        >
            <FormGroup validationState={!item[0]?.name ? 'error' : 'success'}>
                <Label required className="control-label">
                    {i18n('Name')}
                </Label>
                {bowtieAdmin ? (
                    <FormControl
                        type="text"
                        id="barrierEditor-escalationEditModal-field-name"
                        onChange={e => {
                            item[0].name = (e.target as HTMLInputElement).value
                            handleChange()
                        }}
                        value={item[0]?.name || ''}
                    />
                ) : (
                    <FormControl
                        readOnly
                        type="text"
                        id="barrierEditor-escalationEditModal-field-name"
                        onChange={e => {
                            item[0].name = (e.target as HTMLInputElement).value
                            handleChange()
                        }}
                        value={item[0]?.name || ''}
                    />
                )}
            </FormGroup>
        </EntityEditorModal>
    )
}
